/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentForReport,
  OrderPaymentForReportOptional,
  OrderPaymentForReportMetaI,
  OrderPaymentForReportTrackedI,
} from "./order-payment-for-report";
import {
  OrderPaymentForReportTracked,
  OrderPaymentForReportMeta,
} from "./order-payment-for-report";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentStatus,
  PaymentStatusOptional,
  PaymentStatusMetaI,
  PaymentStatusTrackedI,
} from "./payment-status";
import { PaymentStatusTracked, PaymentStatusMeta } from "./payment-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";

/**
 *
 * @export
 * @interface OrderPaymentBase
 */
export interface OrderPaymentBaseOptional extends OrderPaymentForReportOptional {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentBase
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentBase
   */
  expiresOn?: Date;
}

export interface OrderPaymentBase
  extends OrderPaymentBaseOptional, OrderPaymentForReport {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentBase
   */
  paymentType: PaymentType;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentBase
   */
  paymentStatus: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentBase
   */
  expiresOn?: Date;
}

export interface OrderPaymentBaseTrackedI extends OrderPaymentForReportOptional {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentBase
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentBase
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentRecordId?: string;
  paymentRecordIdIsSet: boolean;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentBase
   */
  paymentStatus?: PaymentStatus;
  paymentStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentDueDate?: Date;
  paymentDueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  paymentPaidDate?: Date;
  paymentPaidDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentBase
   */
  squarePaymentId?: string;
  squarePaymentIdIsSet: boolean;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentBase
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
}

transformDatesMap.set("OrderPaymentBase", function (model: OrderPaymentBase) {
  if (typeof model.paymentCapturableDate == "string")
    model.paymentCapturableDate = new Date(model.paymentCapturableDate);
  if (typeof model.paymentDueDate == "string")
    model.paymentDueDate = new Date(model.paymentDueDate);
  if (typeof model.paymentPaidDate == "string")
    model.paymentPaidDate = new Date(model.paymentPaidDate);
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
});

export type OrderPaymentBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentRecordId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentStatus: PropertyMeta<PaymentStatusMetaI>;
  //isDate: false
  //isDatetime: true
  paymentDueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  paymentPaidDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  squarePaymentId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var OrderPaymentBaseMeta: OrderPaymentBaseMetaI =
  {} as OrderPaymentBaseMetaI;
OrderPaymentBaseMeta = typeMeta("OrderPaymentBase", {
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentType: propertyMeta("paymentType", false, true, false, PaymentTypeMeta),
  paymentRecordId: propertyMeta(
    "paymentRecordId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  paymentStatus: propertyMeta(
    "paymentStatus",
    false,
    true,
    false,
    PaymentStatusMeta,
  ),
  paymentDueDate: propertyMeta(
    "paymentDueDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidDate: propertyMeta(
    "paymentPaidDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  squarePaymentId: propertyMeta(
    "squarePaymentId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
});

const metaI = OrderPaymentBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentForReportMeta]);
  metaI.paymentServiceChangeCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentServiceChangeCents;
  metaI.paymentCapturableCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentCapturableCents;
  metaI.paymentCapturableDate.inheritedFrom =
    OrderPaymentForReportMeta.paymentCapturableDate;
  metaI.paymentPaidCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentPaidCents;
  metaI.paymentTotalCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentTotalCents;
  metaI.paymentRefundedCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentRefundedCents;
  metaI.paymentToRefundCents.inheritedFrom =
    OrderPaymentForReportMeta.paymentToRefundCents;
});

export class OrderPaymentBaseTracked
  extends OrderPaymentForReportTracked
  implements OrderPaymentBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentRecordId__I?: string = undefined;
  paymentRecordIdIsSet: boolean = false;
  set paymentRecordId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentRecordId__I = v;
      this.paymentRecordIdIsSet = true;
    } else {
      this.paymentRecordId__I = v || undefined;
      this.paymentRecordIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRecordId() {
    return this.paymentRecordId__I;
  }
  paymentStatus__I?: PaymentStatus = undefined;
  paymentStatusIsSet: boolean = false;
  set paymentStatus(v: undefined | PaymentStatus) {
    if (v !== undefined) {
      this.paymentStatus__I = v;
      this.paymentStatusIsSet = true;
    } else {
      this.paymentStatus__I = v || undefined;
      this.paymentStatusIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentStatus() {
    return this.paymentStatus__I;
  }
  paymentDueDate__I?: Date = undefined;
  paymentDueDateIsSet: boolean = false;
  set paymentDueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentDueDate__I = v;
      this.paymentDueDateIsSet = true;
    } else {
      this.paymentDueDate__I = v || undefined;
      this.paymentDueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDueDate() {
    return this.paymentDueDate__I;
  }
  paymentPaidDate__I?: Date = undefined;
  paymentPaidDateIsSet: boolean = false;
  set paymentPaidDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentPaidDate__I = v;
      this.paymentPaidDateIsSet = true;
    } else {
      this.paymentPaidDate__I = v || undefined;
      this.paymentPaidDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidDate() {
    return this.paymentPaidDate__I;
  }
  squarePaymentId__I?: string = undefined;
  squarePaymentIdIsSet: boolean = false;
  set squarePaymentId(v: undefined | string) {
    if (v !== undefined) {
      this.squarePaymentId__I = v;
      this.squarePaymentIdIsSet = true;
    } else {
      this.squarePaymentId__I = v || undefined;
      this.squarePaymentIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squarePaymentId() {
    return this.squarePaymentId__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  constructor(config?: OrderPaymentBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderPaymentBaseOptional,
    options?: AssignOptions,
  ): OrderPaymentBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentRecordId &&
      this.paymentRecordIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRecordId = config.paymentRecordId;
      if (optionsRequired.unassign) this.paymentRecordIdIsSet = false;
      else this.paymentRecordIdIsSet = true;
    }
    if (
      config.paymentStatus &&
      this.paymentStatusApplyFilter(optionsRequired.filter)
    ) {
      this.paymentStatus = config.paymentStatus;
      if (optionsRequired.unassign) this.paymentStatusIsSet = false;
      else this.paymentStatusIsSet = true;
    }
    if (
      config.paymentDueDate &&
      this.paymentDueDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDueDate = config.paymentDueDate;
      if (optionsRequired.unassign) this.paymentDueDateIsSet = false;
      else this.paymentDueDateIsSet = true;
    }
    if (
      config.paymentPaidDate &&
      this.paymentPaidDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidDate = config.paymentPaidDate;
      if (optionsRequired.unassign) this.paymentPaidDateIsSet = false;
      else this.paymentPaidDateIsSet = true;
    }
    if (
      config.squarePaymentId &&
      this.squarePaymentIdApplyFilter(optionsRequired.filter)
    ) {
      this.squarePaymentId = config.squarePaymentId;
      if (optionsRequired.unassign) this.squarePaymentIdIsSet = false;
      else this.squarePaymentIdIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderPaymentBaseTrackedI {
    const cloned = {} as OrderPaymentBaseTrackedI;
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentRecordIdIsSetDeep() &&
      this.paymentRecordIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRecordIdIsSet = true;
      cloned.paymentRecordId = this.paymentRecordId;
    } else {
      //cloned.paymentRecordIdIsSet = false
    }
    if (
      this.paymentStatusIsSetDeep() &&
      this.paymentStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentStatusIsSet = true;
      cloned.paymentStatus = this.paymentStatus;
    } else {
      //cloned.paymentStatusIsSet = false
    }
    if (
      this.paymentDueDateIsSetDeep() &&
      this.paymentDueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDueDateIsSet = true;
      cloned.paymentDueDate = this.paymentDueDate;
    } else {
      //cloned.paymentDueDateIsSet = false
    }
    if (
      this.paymentPaidDateIsSetDeep() &&
      this.paymentPaidDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidDateIsSet = true;
      cloned.paymentPaidDate = this.paymentPaidDate;
    } else {
      //cloned.paymentPaidDateIsSet = false
    }
    if (
      this.squarePaymentIdIsSetDeep() &&
      this.squarePaymentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squarePaymentIdIsSet = true;
      cloned.squarePaymentId = this.squarePaymentId;
    } else {
      //cloned.squarePaymentIdIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderPaymentBaseTrackedI {
    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentRecordIdApplyFilter(filter))
      this.paymentRecordIdIsSet = false;

    if (!this.paymentStatusApplyFilter(filter)) this.paymentStatusIsSet = false;

    if (!this.paymentDueDateApplyFilter(filter))
      this.paymentDueDateIsSet = false;

    if (!this.paymentPaidDateApplyFilter(filter))
      this.paymentPaidDateIsSet = false;

    if (!this.squarePaymentIdApplyFilter(filter))
      this.squarePaymentIdIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    return this;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentServiceChangeCents,
      OrderPaymentBaseMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentCapturableCents,
      OrderPaymentBaseMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentCapturableDate,
      OrderPaymentBaseMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentPaidCents,
      OrderPaymentBaseMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentTotalCents,
      OrderPaymentBaseMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentRefundedCents,
      OrderPaymentBaseMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentToRefundCents,
      OrderPaymentBaseMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentType,
      OrderPaymentBaseMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentRecordIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentRecordId,
      OrderPaymentBaseMeta,
      this.paymentRecordId,
      this,
    );
  }
  paymentRecordIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentRecordIdIsSet && this.paymentRecordIdApplyFilter(filter))
      return true;

    return false;
  }
  paymentStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentStatus,
      OrderPaymentBaseMeta,
      this.paymentStatus,
      this,
    );
  }
  paymentStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentStatusIsSet && this.paymentStatusApplyFilter(filter))
      return true;

    return false;
  }
  paymentDueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentDueDate,
      OrderPaymentBaseMeta,
      this.paymentDueDate,
      this,
    );
  }
  paymentDueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentDueDateIsSet && this.paymentDueDateApplyFilter(filter))
      return true;

    return false;
  }
  paymentPaidDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.paymentPaidDate,
      OrderPaymentBaseMeta,
      this.paymentPaidDate,
      this,
    );
  }
  paymentPaidDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidDateIsSet && this.paymentPaidDateApplyFilter(filter))
      return true;

    return false;
  }
  squarePaymentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.squarePaymentId,
      OrderPaymentBaseMeta,
      this.squarePaymentId,
      this,
    );
  }
  squarePaymentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squarePaymentIdIsSet && this.squarePaymentIdApplyFilter(filter))
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentBaseMeta.expiresOn,
      OrderPaymentBaseMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentRecordIdIsSetDeep(filter)) return true;
    if (this.paymentStatusIsSetDeep(filter)) return true;
    if (this.paymentDueDateIsSetDeep(filter)) return true;
    if (this.paymentPaidDateIsSetDeep(filter)) return true;
    if (this.squarePaymentIdIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
